var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-toast',{staticClass:"base-toast-main",attrs:{"title":_vm.$t('knowledge.update-status.error-toast.title'),"description":_vm.$t('knowledge.update-status.error-toast.description'),"type":"error","use-emit":""},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }